import type { FC } from "preact/compat";

export interface FilterSearchBtnProps {
  href?: string;
  label?: string;
  disabled?: boolean;
  onClick?: (e: MouseEvent) => void;
}

export const FilterSearchBtn: FC<FilterSearchBtnProps> = ({
  href,
  label,
  disabled,
  onClick,
}) => (
  <a
    className="shadow block md:w-32 w-full md:inline-block py-3 px-4 border border-gt-black rounded-lg font-medium cursor-pointer text-gt-black text-center bg-gt-lilac transition-all hover:translate-x-1 hover:shadow-gt sbc"
    disabled={disabled}
    {...{
      ...(href && { href }),
      ...(onClick && { onClick }),
    }}
  >
    <span className="flex gap-2 items-center justify-center">
      <svg
        width="17"
        height="24"
        viewBox="0 0 17 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.75 18.7188C16.0625 19.0312 16.0625 19.5 15.75 19.7812C15.625 19.9375 15.4375 20 15.25 20C15.0312 20 14.8438 19.9375 14.6875 19.7812L10.5 15.5938C9.375 16.5 7.96875 17 6.46875 17C2.90625 17 0 14.0938 0 10.5C0 6.9375 2.875 4 6.46875 4C10.0312 4 12.9688 6.9375 12.9688 10.5C12.9688 12.0312 12.4688 13.4375 11.5625 14.5312L15.75 18.7188ZM1.5 10.5C1.5 13.2812 3.71875 15.5 6.5 15.5C9.25 15.5 11.5 13.2812 11.5 10.5C11.5 7.75 9.25 5.5 6.5 5.5C3.71875 5.5 1.5 7.75 1.5 10.5Z"
          fill="#353535"
        ></path>
      </svg>
      {label}
    </span>
  </a>
);
